import React from 'react';



const LinkInformationArea = () => {
  return (
    <section id="note">
      <dl>
        <dt>リンク集について</dt>
        <dd>登録は自薦・他薦問わず誰でも可能です。</dd>
        <dd>登録されたサイトは内容を確認し、問題無いと判断されたサイトのみ掲載されます。</dd>
        <dd>リンクに関する削除依頼などは「<a href="https://x.com/vast_z" target="_blank" rel="noopener noreferrer">@vast_z</a>」もしくは「<a href="mailto:info@ffxiv-pt.com">info@ffxiv-pt.com</a>」までお願い致します。</dd>
        <dd>当サイトを利用して起きたいかなるトラブルについても、当サイトは一切責任を負いません。</dd>
      </dl>
    </section>
  );
};

export default LinkInformationArea;